import { render } from "./ServicesComp.vue?vue&type=template&id=71824028"
import script from "./ServicesComp.vue?vue&type=script&lang=js"
export * from "./ServicesComp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/new-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__